<div id="project-count-container"  class="row">
  @for (count of filteredProjectCount; track count) {
    <div class="col-md-4">
      <h1 class="card-count mb-0 text-center">{{ count.value }}</h1>
      <div class="font-12 text-center">{{ count.key }}</div>
    </div>
  }
</div>
